import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const POSITIONS = ["Senior React Developer", "Backend Engineer (Java)", "Data Scientist", "DevOps SRE", "Product Manager"];
const ROUNDS = ["L1 — Initial screen", "L2 — Technical depth", "L3 — Hiring manager"];
const LOCATIONS = ["Bengaluru", "Mumbai", "Delhi NCR", "Pune", "Remote"];
const CHANNELS = ["Email", "WhatsApp", "Both"];
const TEMPLATES = ["Standard invite", "Senior role invite", "Campus invite", "Reschedule notice"];
const TIMEZONES = ["Asia/Kolkata (IST)", "America/Los_Angeles (PT)", "America/New_York (ET)", "Europe/London (GMT)", "Asia/Singapore (SGT)"];

const isoDefault = (offsetHours) => {
  const d = new Date(Date.now() + offsetHours * 3600000);
  // Format as datetime-local (yyyy-MM-ddThh:mm)
  return d.toISOString().slice(0, 16);
};

const InviteIndividually = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    position: POSITIONS[0],
    round: ROUNDS[0],
    location: LOCATIONS[0],
    firstName: "",
    lastName: "",
    email: "",
    whatsapp: "",
    channel: "Both",
    template: TEMPLATES[0],
    opens: isoDefault(1),
    expires: isoDefault(72),
    timezone: TIMEZONES[0],
  });
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => { document.title = "Invite individually - Ample Hire"; }, []);

  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const send = async () => {
    if (!form.firstName.trim() || !form.email.trim()) {
      setResult({ ok: false, message: "First name and email are required" });
      return;
    }
    setSubmitting(true); setResult(null);
    // Stub: pretend to enqueue invite
    setTimeout(() => {
      setResult({ ok: true, message: `Invite sent to ${form.firstName} ${form.lastName} via ${form.channel}` });
      setSubmitting(false);
    }, 500);
  };

  return (
    <div className="app-content page-enter" style={{ maxWidth: 880, margin: "0 auto", padding: "20px 24px 32px" }}>
      <div style={hdrRow}>
        <div>
          <h1 style={hdrTitle}>Invite individually</h1>
          <p style={hdrSub}>{form.position} — add one candidate at a time with full control</p>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={() => alert("Stub: bulk CSV upload")} style={btnGhost}>Bulk CSV upload</button>
          <button onClick={() => alert("Stub: WhatsApp blast")} style={{ ...btnGhost, background: "#25D366", color: "white", border: "none" }}>WhatsApp blast</button>
          <button onClick={() => alert("Stub: public link copied")} style={btnGhost}>Public link</button>
        </div>
      </div>

      <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.25 }} style={card}>
        <div style={cardLabel}>Add candidate</div>

        <Row3>
          <Field label="Position">
            <Select v={form.position} onChange={(v) => update("position", v)} options={POSITIONS} />
          </Field>
          <Field label="Round">
            <Select v={form.round} onChange={(v) => update("round", v)} options={ROUNDS} />
          </Field>
          <Field label="Location">
            <Select v={form.location} onChange={(v) => update("location", v)} options={LOCATIONS} />
          </Field>
        </Row3>

        <Row2>
          <Field label="First name *">
            <input value={form.firstName} onChange={(e) => update("firstName", e.target.value)} style={input} />
          </Field>
          <Field label="Last name">
            <input value={form.lastName} onChange={(e) => update("lastName", e.target.value)} style={input} />
          </Field>
        </Row2>

        <Row2>
          <Field label="Email *">
            <input type="email" value={form.email} onChange={(e) => update("email", e.target.value)} placeholder="candidate@example.com" style={input} />
          </Field>
          <Field label="WhatsApp">
            <input value={form.whatsapp} onChange={(e) => update("whatsapp", e.target.value)} placeholder="+91 98765 43210" style={input} />
          </Field>
        </Row2>

        <Row2>
          <Field label="Channel">
            <div style={{ display: "flex", gap: 4 }}>
              {CHANNELS.map((c) => (
                <button key={c} onClick={() => update("channel", c)} style={{
                  flex: 1, padding: "8px 12px", borderRadius: 100, fontSize: 11, fontWeight: 600,
                  border: form.channel === c ? "1px solid #7B5AC4" : "1px solid #E2E8F0",
                  background: form.channel === c ? "#EEF2FF" : "white",
                  color: form.channel === c ? "#4338CA" : "#64748B", cursor: "pointer",
                }}>{c}</button>
              ))}
            </div>
          </Field>
          <Field label="Template">
            <Select v={form.template} onChange={(v) => update("template", v)} options={TEMPLATES} />
          </Field>
        </Row2>

        <Row3>
          <Field label="Opens at">
            <input type="datetime-local" value={form.opens} onChange={(e) => update("opens", e.target.value)} style={input} />
          </Field>
          <Field label="Expires at">
            <input type="datetime-local" value={form.expires} onChange={(e) => update("expires", e.target.value)} style={input} />
          </Field>
          <Field label="Timezone">
            <Select v={form.timezone} onChange={(v) => update("timezone", v)} options={TIMEZONES} />
          </Field>
        </Row3>

        {result && (
          <div style={{
            marginTop: 8, padding: 10, borderRadius: 6, fontSize: 12,
            background: result.ok ? "#ECFDF5" : "#FEF2F2",
            border: result.ok ? "1px solid #10B981" : "1px solid #FCA5A5",
            color: result.ok ? "#047857" : "#991B1B",
          }}>
            {result.ok ? "✓" : "✗"} {result.message}
          </div>
        )}

        <div style={{ display: "flex", gap: 8, marginTop: 16, justifyContent: "flex-end" }}>
          <button onClick={() => navigate("/admin/invited-candidates")} style={btnGhost}>Cancel</button>
          <button style={btnGhost}>Add to queue</button>
          <button onClick={() => alert("Stub: scheduled")} style={btnGhost}>Schedule for later</button>
          <button onClick={send} disabled={submitting} style={{ ...btnPrimary, opacity: submitting ? 0.5 : 1 }}>
            {submitting ? "Sending…" : "Send invitation now"}
          </button>
        </div>
      </motion.div>
    </div>
  );
};

const Select = ({ v, onChange, options }) => (
  <select value={v} onChange={(e) => onChange(e.target.value)} style={input}>
    {options.map((o) => <option key={o} value={o}>{o}</option>)}
  </select>
);

const Field = ({ label, children }) => (
  <div style={{ marginBottom: 12 }}>
    <div style={{ fontSize: 10, color: "#64748B", marginBottom: 4, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.4 }}>{label}</div>
    {children}
  </div>
);
const Row2 = ({ children }) => <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>{children}</div>;
const Row3 = ({ children }) => <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>{children}</div>;
const card = { background: "white", border: "1px solid #E2E8F0", borderRadius: 12, padding: 16 };
const cardLabel = { fontSize: 11, fontWeight: 700, color: "#94A3B8", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 12 };
const input = { width: "100%", padding: "8px 12px", border: "1px solid #E2E8F0", borderRadius: 6, fontSize: 13, color: "#0F172A", outline: "none", background: "white", boxSizing: "border-box" };
const hdrRow = { display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginBottom: 16 };
const hdrTitle = { fontSize: 22, fontWeight: 700, color: "#0F172A", margin: 0 };
const hdrSub = { fontSize: 13, color: "#64748B", margin: "4px 0 0" };
const btnPrimary = { padding: "9px 18px", borderRadius: 6, background: "#7B5AC4", color: "white", border: "none", fontWeight: 600, fontSize: 13, cursor: "pointer" };
const btnGhost = { padding: "8px 14px", borderRadius: 6, background: "white", color: "#475569", border: "1px solid #E2E8F0", fontWeight: 600, fontSize: 12, cursor: "pointer" };

export default InviteIndividually;
